/**
 * Medium Zoom Lib
 *
 * @module medium-zoom
 *  @version 1.0.0
 * 
 */

const component = {

	/**
	 * Init module
     * @returns {undefined}
	 */
	init: () => {
        
        document.querySelectorAll('[data-zoomable] img').forEach(element => {
            let zoom = mediumZoom(element);

            element.addEventListener('click', event => {
                zoom.toggle();
            });
        });
	},
};

export default component;
